// サブディレクトリ独自対応
/**
 * サブディレクトリを取得する関数
 * @param {string} routePath - 現在のルートパス
 * @returns {string|null} - 一致するサブディレクトリまたは null
 */
export function getActiveSubDirectory(routePath) {
    const subDirectories = process.env.VUE_APP_SUBDIRECTORY
    const subDirs = subDirectories ? subDirectories.split(";") : [];
    // 現在のパスに一致するサブディレクトリを探す
    return subDirs.find(subDir => routePath.includes(subDir)) || null;
  }
  
  /**
   * Aboutリンクを表示するかどうかを判定する関数
   * @param {string} aboutLinkPath - チェックするパス
   * @returns {boolean} - Aboutリンクを表示するかどうか
   */
export function checkIfShouldShowAboutLink(aboutLinkPath) {
    const showAboutLinkPaths = process.env.VUE_APP_SHOW_ABOUT_LINK
    const showPaths = showAboutLinkPaths ? showAboutLinkPaths.split(";") : [];
    return showPaths.some(path => aboutLinkPath === path);
  }